import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { useBalanceSummary } from 'src/hooks';
import { CurrencyField } from 'src/lib';
import { FlexDirection } from 'src/styles';

import * as Styles from './Header.styles';

export const AccountValue = () => {
  const { accountValue } = useBalanceSummary();

  return (
    <Row justify='center' align='middle' className={cx(Styles.accountValueContainer, FlexDirection.column)}>
      <Col span={24}>
        <CurrencyField value={accountValue.value} className={Styles.accountValue} />
      </Col>
      <Col span={24}>
        <span className={Styles.accountLabel}>Account Value</span>
      </Col>
    </Row>
  );
};
